import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { FunilVendaSelectComponent } from './funil-venda-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        FunilVendaSelectComponent
    ],
    exports: [
        FunilVendaSelectComponent
    ]
})
export class FunilVendaSelectModule { }
